import axios from 'axios'
import { BASE_URL, API_VERSION, PRIZES } from '../endpoints'
import { GET_RAFFLE } from './RaffleActions'
export const GET_ALL_PRIZES = 'GET_ALL_PRIZES'
export const ADD_PRIZE = 'ADD_PRIZE'
export const EDIT_PRIZE = 'EDIT_PRIZE'
export const DELETE_PRIZE = 'DELETE_PRIZE'

export const getAllItems = (page, size, search) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken');
    let options = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };

    return axios.get(`${BASE_URL}${PRIZES}?page=${page}&size=${size}&search=${search}&admin=true`, options)
        .then((response) => {

            dispatch({
                type: GET_ALL_PRIZES,
                payload: {
                    prizes: response.data.data,
                    total: response.data.data.totalElements // Adjust based on API
                }
            });
            return Promise.resolve(response.data.data);
        })
        .catch((error) => {
            return Promise.reject(error.response?.data?.error);
        });
};



export const addItem = (payload) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken')
    let apiHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': `Bearer ` + accessToken,
        }
    }
    return axios.post(BASE_URL + PRIZES, payload, apiHeader)
        .then(response => {
            console.log("response.data", response.data.data, response.data.data.updatedRaffle)

            // Update raffle state if it existst already
            if (payload.raffleId)
                dispatch({
                    type: GET_RAFFLE,
                    payload: {
                        raffle: response.data.data.updatedRaffle,
                    }
                });
            // Otherwise return the new prize
            return Promise.resolve(response.data.data)
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}

export const deleteItem = (id) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken')
    let apiHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };
    return axios.delete(BASE_URL + PRIZES + '/' + id, apiHeader)
        .then(response => {
            // dispatch({ type: DELETE_PRIZE, payload: id });
            return Promise.resolve(response.data)
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}

export const editItem = (id, payload) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken')
    let apiHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };
    return axios.patch(BASE_URL + PRIZES + '/' + id, payload, apiHeader)
        .then(response => {
            // dispatch({ type: EDIT_PRIZE, payload: response.data });
            return Promise.resolve()
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}